import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Hoe snel kun je spiermassa laten groeien?</title>
                <link rel="canonical" href={route("blogs.thirty-six")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE Personal Training Uden en Schijndel komt weer met een nieuwe blog. Dit keer richten we op alle krachtsporters die graag meer spiermassa willen. Veel van deze krachtsporters zullen het wel merken dat je na een aantal maanden trainen niet meer dezelfde groei maakt als daarvoor. Dit heeft te maken met de potentie van je spiermassa. Lees je met ons mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE Personal Training Uden en Schijndel komt weer met een nieuwe blog. Dit keer richten we op alle krachtsporters die graag meer spiermassa willen. Veel van deze krachtsporters zullen het wel merken dat je na een aantal maanden trainen niet meer dezelfde groei maakt als daarvoor. Dit heeft te maken met de potentie van je spiermassa. Lees je met ons mee?"
                />
                <meta property="og:url" content={route("blogs.thirty-six")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Hoe snel kun je spiermassa laten groeien? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/spiermassa-laten-groeien.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/spiermassa-laten-groeien.webp"
                                    type="image/webp"
                                    alt="Spiermassa laten groeien"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/spiermassa-laten-groeien.jpg"
                                    type="image/jpeg"
                                    alt="Spiermassa laten groeien"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/spiermassa-laten-groeien.jpg"
                                    alt="Spiermassa laten groeien"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hoe snel kun je spiermassa laten groeien?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE Personal Training Uden en Schijndel komt weer met
                        een nieuwe blog. Dit keer richten we op alle
                        krachtsporters die graag meer spiermassa willen. Veel
                        van deze krachtsporters zullen het wel merken dat je na
                        een aantal maanden trainen niet meer dezelfde groei
                        maakt als daarvoor. Dit heeft te maken met de{" "}
                        <a
                            href={route("blogs.twenty-eight")}
                            className="text-we-are-yellow"
                        >
                            potentie
                        </a>{" "}
                        van je spiermassa. Lees je met ons mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe laat je spiermassa groeien?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het winnen van spiermassa is een fysiologisch proces
                        waarbij twee dingen heel belangrijk zijn. De eerste is
                        om voldoende te eten zodat je spieren de kans krijgen om
                        te groeien. Naast de energie die het lichaam nodig heeft
                        om de vitale functies te laten draaien heeft het nog
                        extra energie nodig om je spieren te laten groeien.
                        Hiervoor zijn voornamelijk{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            eiwitten
                        </a>{" "}
                        en koolhydraten nodig. Wat er in de praktijk gebeurd is
                        dat krachtsporters gaan{" "}
                        <a
                            href={route("blogs.thirteenth")}
                            className="text-we-are-yellow"
                        >
                            'bulken en cutten'
                        </a>{" "}
                        . Het tweede wat belangrijk is, is het prikkelen van je
                        spieren. Door{" "}
                        <a
                            href={route("blogs.thirty-four")}
                            className="text-we-are-yellow"
                        >
                            progressieve overload
                        </a>{" "}
                        toe te passen tijdens je trainingen stimuleer je de
                        groei van je spiermassa.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe snel kan je spiermassa laten groeien?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De snelheid van groei is afhankelijk van meerdere
                        factoren zoals inzet,{" "}
                        <a
                            href={route("blogs.twenty-five")}
                            className="text-we-are-yellow"
                        >
                            voeding
                        </a>{" "}
                        en{" "}
                        <a
                            href={route("blogs.twenty-eight")}
                            className="text-we-are-yellow"
                        >
                            genetische aanleg
                        </a>{" "}
                        . We gaan er in deze blog vanuit dat we allemaal gelijk
                        zijn in genen om een beeld te geven over de mate van
                        groei. We onderscheiden hiervoor drie niveaus:
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc">
                        <li>Beginner (0 - 9 maanden)</li>
                        <li>Gevorderd (12 - 36 maanden)</li>
                        <li>Expert (36+ maanden)</li>
                    </ul>
                    <table className="min-w-full divide-y divide-we-are-purple mt-4">
                        <thead className="bg-we-are-purple">
                            <tr>
                                <th
                                    scope="col"
                                    className="text-center py-3.5 pl-4 pr-3 text-base font-semibold text-gray-300 sm:pl-6"
                                >
                                    Niveau
                                </th>
                                <th
                                    scope="col"
                                    className="px-3 py-3.5 text-center text-base font-semibold text-gray-300"
                                >
                                    Toename lichaamsgewicht per week
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-we-are-purple bg-gray-300">
                            <tr>
                                <td className="whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-we-are-purple sm:pl-6">
                                    Beginner
                                </td>
                                <td className="whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-we-are-purple sm:pl-6">
                                    1 - 1,5%
                                </td>
                            </tr>
                            <tr>
                                <td className="whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-we-are-purple sm:pl-6">
                                    Gevorderd
                                </td>
                                <td className="whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-we-are-purple sm:pl-6">
                                    0,5 - 0,75%
                                </td>
                            </tr>
                            <tr>
                                <td className="whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-we-are-purple sm:pl-6">
                                    Expert
                                </td>
                                <td className="whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-we-are-purple sm:pl-6">
                                    1 0,25 - 0,5%
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="mt-4 text-gray-100 break-words">
                        In de tabel hierboven is te zien wat de gewichtstoename
                        per week kan zijn zonder vet aan te komen. Wanneer je
                        meer gewicht aankomt dan bovenstaande informatie is de
                        kans groot dat je aan bent aangekomen in vetmassa. Wat
                        belangrijk is om te zien is dat, hoe langer je traint,
                        hoe langer de groei gaat. Een beginner kan zijn veel
                        sneller spiermassa vergroten dan een expert. Hoe verder
                        je in dit avontuur komt hier groter de rol wordt van je
                        genetische potentie in spiermassa.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Je vooruitgang meten aan de hand van je gewicht kan je
                        doen na het lezen van{" "}
                        <a
                            href={route("blogs.twenty-six")}
                            className="text-we-are-yellow"
                        >
                            deze blog
                        </a>{" "}
                        .
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Wil je jouw transformatie maken en je spiermassa laten
                        groeien binnen twaalf weken? Stuur ons dan een bericht
                        en we contacteren je snel!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
